// Kullanıcı servisi - Kullanıcı API çağrıları
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Token'ı otomatik ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Kullanıcı servis fonksiyonları
export const userService = {
  // Kullanıcı listesini al
  async getUsers(params = {}) {
    try {
      const response = await api.get('/users', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Kullanıcı detaylarını al
  async getUser(id) {
    try {
      const response = await api.get(`/users/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Yeni kullanıcı oluştur
  async createUser(userData) {
    try {
      const response = await api.post('/users', userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Kullanıcı güncelle
  async updateUser(id, userData) {
    try {
      const response = await api.put(`/users/${id}`, userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Kullanıcı sil
  async deleteUser(id) {
    try {
      const response = await api.delete(`/users/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Kullanıcı şifresini sıfırla
  async resetUserPassword(id) {
    try {
      const response = await api.post(`/users/${id}/reset-password`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Şifre sıfırlama (alias)
  async resetPassword(id) {
    return this.resetUserPassword(id);
  },

  // Şifre güncelle
  async updatePassword(id, newPassword) {
    try {
      const response = await api.put(`/users/${id}/password`, { password: newPassword });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Yönetici listesini al
  async getManagers() {
    try {
      const response = await api.get('/users/managers/list');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  ,
  // Hedefler - listele
  async getUserGoals(userId) {
    try {
      const response = await api.get(`/users/goals/${userId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  ,
  // Hedef ilerleme - tamamlanma sayıları ve oranı
  async getUserGoalsProgress(userId) {
    try {
      const response = await api.get(`/users/goals/${userId}/progress`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  ,
  // Hedef ekle
  async addUserGoal(goal) {
    try {
      const response = await api.post('/users/goals', goal);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  ,
  // Hedef güncelle
  async updateUserGoal(goalId, goal) {
    try {
      const response = await api.put(`/users/goals/${goalId}`, goal);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  ,
  // Hedef sil
  async deleteUserGoal(goalId) {
    try {
      const response = await api.delete(`/users/goals/${goalId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
